import { getQuotationMarksForLocalePreference } from '../../utils/i18n/quotationStyleUtils';

export type QuotationCssCustomProperties = {
    '--mn-quote-outer-open': string;
    '--mn-quote-outer-close': string;
    '--mn-quote-inner-open': string;
    '--mn-quote-inner-close': string;
};

/**
 * Wraps a quote character in a CSS-safe single-quoted string.
 */
const getCssCustomPropertyStringValue = (value: string): string => `'${value.replaceAll("'", "\\'")}'`;

/**
 * Returns locale-aware quote CSS custom properties for tiptap blockquote rendering.
 */
export const getQuotationCssCustomProperties = (localePreference?: string): QuotationCssCustomProperties => {
    const marks = getQuotationMarksForLocalePreference(localePreference);
    return {
        '--mn-quote-outer-open': getCssCustomPropertyStringValue(marks.outerOpen),
        '--mn-quote-outer-close': getCssCustomPropertyStringValue(marks.outerClose),
        '--mn-quote-inner-open': getCssCustomPropertyStringValue(marks.innerOpen),
        '--mn-quote-inner-close': getCssCustomPropertyStringValue(marks.innerClose),
    };
};
